import { call } from "redux-saga/effects";
import * as HttpService from 'services/HttpService';
import { takeLatest, put } from 'redux-saga/effects';
import {
    loginRequest,
    authenticated,
    autoAuthenticated,
    signInFailed,
    signOutSuccess,
    logoutRequest,
    verifyHash,
    verifyHashSuccess,
    verifyHashFailed,
    setupPassword,
    setupPasswordSuccess,
    setupPasswordFailed,
} from "../slices/authSlice";
import {AUTH_TOKEN} from "constants/AuthConstant";
import {notification} from "antd";

export function* me() {
    try {
        const token = localStorage.getItem(AUTH_TOKEN)
        if (token) {
            const response = yield call(HttpService.get, '/auth/me');
            if (response && response.data) {
                const { user } = response.data || null;
                if (user) {
                    yield put(autoAuthenticated(user));
                }
            }
        }
    } catch (error) {
        if (error) {
            yield put(signInFailed(error?.message || "Something went wrong, please try again"));
        } else {
            yield put(signInFailed("Something went wrong, please try again."));
        }
    }
}

function* login(action) {
    const { email, password } = action.payload;
    const payload = {
        email,
        password,
        source: 'w',
    };
    try {
        const response = yield call(HttpService.post, '/auth/login', payload);
        const { user } = response.data;
        if (user) {
            yield put(authenticated(user));
        } else {
            yield put(signInFailed(response?.description || "Something went wrong, please try again"));
        }
    } catch (error) {
        if (error) {
            yield put(signInFailed(error?.message || "Something went wrong, please try again"));
        } else {
            yield put(signInFailed("Something went wrong, please try again."));
        }
    }
}

function* verifyResetPassHash(action) {
    const {token} = action.payload;
    try {
        const response = yield call(HttpService.post, '/auth/validate_reset_password_token', {token});
        if (response.data) {
            yield put(verifyHashSuccess());
        } else {
            yield put(verifyHashFailed("Something went wrong, please try again."));
        }
    } catch (error) {
        yield put(verifyHashFailed("Something went wrong, please try again."));
    }
}

function* setupFTPassword(action) {
    const {token, new_password} = action.payload;
    try {
        const response = yield call(HttpService.post, '/auth/reset_password', {token, new_password});
        if (response.data) {
            notification.success({type: "success", message: "Password reset successfully."});
            yield put(setupPasswordSuccess());
        } else {
            yield put(setupPasswordFailed("Something went wrong, please try again."));
        }
    } catch (error) {
        yield put(setupPasswordFailed("Something went wrong, please try again."));
    }
}

function* logout() {
    localStorage.removeItem(AUTH_TOKEN);
    yield put(signOutSuccess());
    return true
}

export default function* authSaga() {
    yield takeLatest(loginRequest.type, login);
    yield takeLatest(logoutRequest.type, logout);
    yield takeLatest(verifyHash.type, verifyResetPassHash);
    yield takeLatest(setupPassword.type, setupFTPassword);

    yield me();
}
